/**
 * Quem vê um recurso dentro da tela (feature spotlight). Em um arquivo próprio, sem importar o
 * registro, para o layout usar a regra sem puxar o catálogo de menu junto.
 */

/**
 * A pessoa vê este recurso? Mesma regra do item de menu: o superadmin vê tudo; os demais precisam
 * do nível do papel, da permissão e (fora do trial) do recurso do plano.
 *
 * @param {object} target uma entrada de `SPOTLIGHT_TARGETS`
 * @param {{
 *   isSuper?: boolean,
 *   isTrial?: boolean,
 *   maxRoleLevel?: number,
 *   hasFeature?: (key: string) => boolean,
 *   hasPermission?: (key: string) => boolean,
 * }} ctx
 */
export function canSeeSpotlightTarget(target, { isSuper = false, isTrial = false, maxRoleLevel = 0, hasFeature, hasPermission } = {}) {
  if (isSuper) return true;
  if (target.minLevel && maxRoleLevel < target.minLevel) return false;
  if (target.permission && !hasPermission?.(target.permission)) return false;
  return isTrial || !target.feature || Boolean(hasFeature?.(target.feature));
}
